import { RSAA, RSAAction } from 'redux-api-middleware';

import * as types from './accountsActionTypes';

export const fetchAccounts = (): RSAAction<string, string, string> => ({
  [RSAA]: {
    endpoint: 'company-accounts',
    method: 'GET',
    types: [types.FETCH_ACCOUNTS_REQUEST, types.FETCH_ACCOUNTS_SUCCESS, types.FETCH_ACCOUNTS_FAILURE],
  },
});
